import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { Fabricante } from 'src/app/models/fabricante';
import { FabricanteService } from 'src/app/services';
import { Notificacion } from '../models/notificacion';
import { NotificacionService } from '../services/notificacion.service';

@Component({
  selector: 'enviar-notificacion',
  templateUrl: './enviar-notificacion.component.html',
  styleUrls: ['./enviar-notificacion.component.css']
})
export class EnviarNotificacionComponent implements OnInit {
  notificacion: Notificacion;

  form: FormGroup;

  fabricantesList: Fabricante[];


  constructor(
    private formBuilder: FormBuilder,
    private fabricanteService: FabricanteService,
    private notificacionService: NotificacionService,
    private messageService: MessageService,

    private location: Location,
    private router: Router) {

    const fabricanteValidators = [Validators.required];

    this.form = this.formBuilder.group({
      fabricante: [null, fabricanteValidators],
      color: ['', [Validators.required, Validators.minLength(3)]],
      comentarios: ['', [Validators.required, Validators.minLength(3)]],
    });

  }

  ngOnInit() {

    this.notificacion = {} as Notificacion;


    this.fabricanteService.getFabricantes().subscribe(
      fabs => this.fabricantesList = fabs
    );


  }

  onSubmit() {
    this.createNotificacion();
  }

  private createNotificacion() {
    this.notificacionService.addNotificacion(
      this.form.value
    ).pipe(first())
      .subscribe({
        next: (noti) => {
          this.notificacion = noti;
          this.form.reset();
          this.messageService.add({ severity: 'success', summary: 'Aviso', detail: 'Notificación enviada' });
        },
        error: error => {
          this.messageService.add({ severity: 'error', summary: 'Aviso', detail: 'Error al guardar' });
        }
      });

  }

  goBack(): void {
    this.location.back();
  }


}
